import React, { useEffect, useState } from 'react'
import styled from '@emotion/styled'

import { LandingPageNumber } from '../../constants'
import useHealthCheck from '../../hooks/useHealthCheck'
import { BrowserUtils } from '../../utils/siteUtils'
import { BodyDivFlex } from '../generic/Basics'
import ICOHeader from '../generic/ICOHeader'
import NavFooter from '../generic/navFooter'
import PageHeader from '../generic/PageHeader'
import useComponentFormValidation from '../generic/useComponentFormValidation'
import MaintenancePage from '../maintenance/Maintenance'
import VehicleSpecs from './VehicleSpecs'
import TrimChangeModal from './TrimChangeModal'
import useVehicleDetails from '../../hooks/components/useVehicleDetails'
import VehicleModificationsModal from './VehicleModificationsModal'
import VehicleDetailsWebComponent from './VehicleDetailsWebComponent'

export default ({ ...props }) => {
  const {
    year,
    make,
    model,
    images,
    urlState,
    updateGlobalState,
    trim,
    offer,
    backClick,
    isIneligible,
    nextClick,
    globalState,
    autoCheckData,
    vinResults,
    experienceState,
    mileage,
    drivetrain,
    drivetrains,
    engine,
    engines,
    color,
    colors,
    transmission,
    transmissions,
    navigateWithState,
    health,
    location,
    saveQuestionResponse
  } = props

  const vehicleData = { year, make, model, trim, color, colors, transmission, transmissions, engine, engines, drivetrain, drivetrains }
  const { displayOrder, disabledArray, singleOption, vin, random, error, vehicleErrors, nextStep, nextDisabled, isError, showModal } = useVehicleDetails({
    ...props,
    urlState,
    updateGlobalState,
    trim,
    isIneligible,
    globalState
  })

  const { displayImages, dealerId, dealerName, isDigitalRetail, isCobrandDR, isIneligibleVehiclesEnabled, isAssigned, vehicleIntoAuction, shouldShowOfferCreationComponent, isCobrand, allowIneligibleVehicle } = props.experienceState
  const [isVehKeyModFormValid, setIsVehKeyModFormValid] = useState(false)
  const isVehDetailsComponentValid = useComponentFormValidation('vehicle-config-form')
  const isKeyModComponentValid = useComponentFormValidation('keys-modifications-form')
  const [vehDetailsAnalytics, setVehDetailsAnalytics] = useState([])
  const isArtBased = props.eligibility?.isArtBased

  // component offer creation flag is on && ineligibleVehicles flag is on && components should show && isAssign offer flow && vehicle is ineligible
  const allowIneligibleVehicleForCobranding = allowIneligibleVehicle && isCobrand
  const allowIneligibleVehicles = isAssigned || allowIneligibleVehicleForCobranding
  const allowIneligibleVehiclesForWebComponent = isIneligibleVehiclesEnabled && shouldShowOfferCreationComponent && allowIneligibleVehicles && !vehicleIntoAuction

  useEffect(() => {
    setIsVehKeyModFormValid(!(isVehDetailsComponentValid && isKeyModComponentValid))
  }, [isVehDetailsComponentValid, isKeyModComponentValid])
  const underMaintenance = useHealthCheck({ includeManheim: isArtBased, reuse: true, landingContextHealth: health })
  const isDesktop = BrowserUtils.isDesktop()
  const amR = props.getQuestionResponse(props.amQ).v
  const qp79 = props.getQuestionResponse('qp/79').v
  const isDisabled = shouldShowOfferCreationComponent ? isVehKeyModFormValid : nextDisabled
  if (shouldShowOfferCreationComponent) {
    props.addImpressions(vehDetailsAnalytics)
  } else {
    const analytics = []
    analytics.push({ key: 'amQ', value: amR })
    analytics.push({ key: 'qp/79', value: qp79 })
    props.addImpressions(analytics)
  }
  ////// **** - This is NEEDED for Array Parameters, stencil is weird (https://stenciljs.com/docs/properties#array-props)  - **** //////
  if (document.querySelector('ico-vehicle-config-hydrator')) {
    const vehicleId = location && parseInt(location.initQueryParams.vehicleid)
    document.querySelector('ico-vehicle-config-hydrator').selectedOptions = vehicleId === trim?.trimId && urlState.o ? urlState.o.map(option => parseInt(option.replace('T', ''))) : []
  }

  return underMaintenance ? (
    <MaintenancePage />
  ) : (
    <>
      <BodyDivFlex isDesktop={isDesktop}>
        <ICOHeader {...{ ...vehicleData, displayImages, urlState, images, nextDisabled: isDisabled, errorFunc: error, updateGlobalState, autoCheckData, vinResults, experienceState, globalState, mileage }} />
        <PageHeader text="Vehicle Details" />
        {shouldShowOfferCreationComponent ? (
          <ContentDiv>
            <VehicleDetailsWebComponent
              dealerId={dealerId}
              dealerName={dealerName}
              isDigitalRetailing={isDigitalRetail || isCobrandDR}
              makeId={make?.makeId}
              mileage={mileage}
              modelId={model?.modelId}
              trimId={trim?.trimId}
              updateGlobalState={updateGlobalState}
              vin={vinResults?.vin ?? null}
              yearId={year?.yearId}
              colorId={color?.colorId}
              transmissionId={transmission?.transmissionId}
              engineId={engine?.engineId}
              drivetrainId={drivetrain?.drivetrainId}
              isValidVehicleConfig={isVehDetailsComponentValid}
              navigateWithState={navigateWithState}
              setVehDetailsAnalytics={setVehDetailsAnalytics}
              urlState={urlState}
              allowIneligibleVehiclesForWebComponent={allowIneligibleVehiclesForWebComponent}
              location={location}
              isOfferCreationComponentEnabled={globalState.isOfferCreationComponentEnabled}
              saveQuestionResponse={saveQuestionResponse}
            />
          </ContentDiv>
        ) : (
          <VehicleSpecs key={random} {...{ ...props, ...vehicleData, displayOrder, disabledArray, singleOption, vin, isIneligible, vehicleErrors, isError }} />
        )}
      </BodyDivFlex>
      <TrimChangeModal changeTrim={props.changeTrim} setShowModal={props.setShowModal} showModal={props.trims && props.trims.some(trim => trim.trimId === +props.showModal) && props.showModal} trims={props.trims} trim={props.trim} />
      <VehicleModificationsModal key={globalState.showModal ? 'vehicleMods1' : 'vehicleMods2'} {...{ ...props, showModal }} />
      <NavFooter
        {...{
          backClick: (...e) => backClick(LandingPageNumber),
          experienceState: props.experienceState,
          offer,
          nextStep,
          nextClick: (...e) => (isDisabled ? error() : nextClick(...e)),
          updateGlobalState,
          globalState: props.globalState,
          nextDisabled: shouldShowOfferCreationComponent && isDisabled
        }}
      />
    </>
  )
}

const ContentDiv = styled.div`
  min-height: 250px;
`
